// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__6FMk+","buttons":"Navbar_buttons__xSqOl","link":"Navbar_link__q8hlj"};